module.exports = __webpack_public_path__ + "img/LanghamBostonMobile.f3c81f6f.jpg";